import { debug as debugGen } from "debug";
import Pipeline from "../Pipeline";
import { UserActionReportReq, UserActionReportRsp } from "../actionTypes";
import { IResultUpdate, ActionResult } from "../types";
import pageManager, { CachePage } from "../page";
import { ACTION_ID } from "./events/Expose";
import { getAllByPage, CacheItem } from "./cache";

const debug = debugGen("vtTracker:ResultUpdate");

export default class ResultUpdate
    extends Pipeline<ActionResult<UserActionReportRsp>>
    implements IResultUpdate {
    process(ar: ActionResult<UserActionReportRsp>): Array<CacheItem> {
        const cp: CachePage = pageManager.getPage(ar.action.el);

        debug("on report end in page %o", cp);

        if (typeof cp === "undefined") {
            return null;
        }

        const action: UserActionReportReq = JSON.parse(ar.action.content);

        // 包含了页面曝光上报的，需要更新一下页面trace_index
        const idx = action.report_infos.findIndex(ri => {
            return (
                ri.page_info.item_infos.findIndex(ii => {
                    return (
                        ii.action_infos[0] &&
                        ii.action_infos[0].action_id === ACTION_ID.PAGE
                    );
                }) >= 0
            );
        });

        debug("page expose action index in result: %d", idx);

        if (
            idx >= 0 &&
            ar.result &&
            ar.result.trace_details &&
            ar.result.trace_details[idx]
        ) {
            cp.traceinfo = {
                ...cp.traceinfo,
                trace_index: ar.result.trace_details[idx],
                trace_detail: ""
            };

            cp.exposeComplete = true;

            debug("update page exposeComplete to true: %o", cp);

            const cps: Array<CacheItem> = getAllByPage(cp.node);

            return cps;
        }

        return null;
    }
}
